import { formatUserFullname } from '@/helpers';
import { CustomUser } from '@/models/custom-user.model';
import { AuthenticationService } from '@/services';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CustomResponse } from '@/models/custom-response.model';

const Notification = namespace('notification');
const Authentication = namespace('authentication');

@Component
export default class AccountDetailView extends Vue {
    @Notification.Action('addSuccess') private addSuccess: any;
    @Notification.Action('addError') private addError: any;
    @Authentication.State('user') private user: CustomUser;
    @Authentication.Action('update') private update: any;

    public inFlight: boolean = false;
    public old_password: string = ''; // tslint:disable-line: variable-name
    public new_password: string = ''; // tslint:disable-line: variable-name
    public new_password_confirmation: string = ''; // tslint:disable-line: variable-name
    public passChange: {
        old: string,
        new: string,
        rep: string,
    } = { old: '', new: '', rep: '' };

    get fullName(): string {
        return formatUserFullname(this.user);
    }

    public editUser: CustomUser = new CustomUser();

    public mounted(): void {
        this.editUser = new CustomUser({
            id: this.user.id,
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            email: this.user.email,
        });
    }

    public handleSubmit(): void {
        if (
            this.editUser.id &&
            this.editUser.first_name &&
            this.editUser.last_name &&
            this.editUser.email
        ) {
            this.update(this.editUser).then(
                (data) => {
                    console.log('data', data);
                }, () => {
                    console.log('FAILED');
                },
            );
        }
    }

    public changePassword(): void {
        if (
            this.passChange.old &&
            this.passChange.new &&
            this.passChange.rep
        ) {
            AuthenticationService.changePassword(
                this.passChange.old,
                this.passChange.new,
                this.passChange.rep,
            ).then(
                (response: CustomResponse<any>) => {
                    this.addSuccess(response.localized);
                },
                (error: CustomResponse<any>) => {
                    this.addError(error.localized, error);
                },
            );
        }
    }

}
